import Swiper, { Navigation, Scrollbar } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

const Slider = (element: HTMLElement) =>
	new Swiper(element, {
		modules: [Navigation, Scrollbar],
		spaceBetween: 48,
		slidesPerView: 1,
		breakpoints: {
			900: {
				slidesPerView: 3,
			}
		},
		centerInsufficientSlides: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		scrollbar: {
			el: ".swiper-scrollbar",
			draggable: true,
		},
	});

export default () => {
	const relatedContentSliders: HTMLElement[] = Array.from(
		document.querySelectorAll(".block.related .slider")
	);

	if (!relatedContentSliders) return;

	relatedContentSliders.map((element: HTMLElement) => Slider(element));
};
